/**
 * The event log's row click: flying the camera to the cell a clicked log
 * entry names.
 */

import type { AtlasLive } from '../atlas';
import type { EventLogHandle } from './panels/eventLog';
import type { SelectionHandle } from './selection.ts';

export interface EventLogClickDeps {
  readonly eventLogHandle: EventLogHandle;
  readonly selection: SelectionHandle;
  readonly live: AtlasLive;
  readonly overlay: HTMLElement;
  renderOverlay(): void;
}

export interface EventLogClickHandle {}

export function createEventLogClick(deps: EventLogClickDeps): EventLogClickHandle {
  const { overlay, renderOverlay } = deps;
  const { eventLog } = deps.eventLogHandle;
  const { applySelection } = deps.selection;

  // ── Event log click handler ─────────────────────────────────────────────
  // Clicking a log row with coords flies the camera to that cell.
  const logEl = overlay.querySelector('#atlas-event-log') as HTMLElement;
  logEl.addEventListener('click', (e) => {
    const row = (e.target as HTMLElement).closest('.atlas-log-row') as HTMLElement | null;
    if (!row) return;
    const idx = Number(row.dataset['log']);
    const entry = eventLog[idx];
    if (!entry || entry.cellX == null || entry.cellZ == null) return;
    // Off `plotSubs` rather than the mesh: the survey is loaded at CLAIM and
    // the whole-file plot only exists below the SURFACE edge.
    const sub = deps.live.plot?.subPlotAt(entry.cellX, entry.cellZ)
      ?? deps.live.plotSubs.find((c) => c.x === entry.cellX && c.z === entry.cellZ)
      ?? null;
    if (sub) {
      deps.live.selectedSub = sub;
      applySelection();
      renderOverlay();
    }
  });
  return {};
}
